/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@carbon/icon-helpers';
import 'prop-types';

var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle2, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle3, _path24, _path25, _path26, _circle4, _circle5, _path27, _circle6, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _circle7, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _circle8, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _circle9, _path147, _path148, _path149, _path150, _path151, _circle10, _path152, _path153, _path154, _path155, _circle11, _circle12, _path156, _path157, _path158, _path159, _circle13, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _switch, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263;
const didWarnAboutDeprecation = {};
const ViewFilled = /*#__PURE__*/React.forwardRef(function ViewFilled(_ref, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5A6.5,6.5,0,1,1,22.5,16,6.51,6.51,0,0,1,16,22.5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewFilled.propTypes = iconPropTypes;
}
const ViewMode_1 = /*#__PURE__*/React.forwardRef(function ViewMode_1(_ref2, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H28V28H4zM4 19H28V21H4zM26 6v6H6V6H26m0-2H6A2 2 0 004 6v6a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewMode_1.propTypes = iconPropTypes;
}
const ViewMode_2 = /*#__PURE__*/React.forwardRef(function ViewMode_2(_ref3, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H28V28H4zM4 19H28V21H4zM12 6v6H6V6h6m0-2H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2zM26 6v6H20V6h6m0-2H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewMode_2.propTypes = iconPropTypes;
}
const ViewOff = /*#__PURE__*/React.forwardRef(function ViewOff(_ref4, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref4;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
      d: "M2.6,11.3l0.7-0.7C2.6,9.8,1.9,9,1.5,8c1-2.5,3.8-4.5,6.5-4.5c0.7,0,1.4,0.1,2,0.4l0.8-0.8C9.9,2.7,9,2.5,8,2.5 C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3C1,9.3,1.7,10.4,2.6,11.3z"
    })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
      d: "M6 7.9c.1-1 .9-1.8 1.8-1.8l.9-.9C7.2 4.7 5.5 5.6 5.1 7.2 5 7.7 5 8.3 5.1 8.8L6 7.9zM15.5 7.8c-.6-1.5-1.6-2.8-2.9-3.7L15 1.7 14.3 1 1 14.3 1.7 15l2.6-2.6c1.1.7 2.4 1 3.7 1.1 3.3-.1 6.3-2.2 7.5-5.3C15.5 8.1 15.5 7.9 15.5 7.8zM10 8c0 1.1-.9 2-2 2-.3 0-.7-.1-1-.3L9.7 7C9.9 7.3 10 7.6 10 8zM8 12.5c-1 0-2.1-.3-3-.8l1.3-1.3c1.4.9 3.2.6 4.2-.8.7-1 .7-2.4 0-3.4l1.4-1.4c1.1.8 2 1.9 2.6 3.2C13.4 10.5 10.6 12.5 8 12.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24,22.51l1.43-1.42A14.06,14.06,0,0,1,3.07,16C5.1,10.93,10.7,7,16,7a12.38,12.38,0,0,1,4,.72l1.55-1.56A14.72,14.72,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16,16,0,0,0,5.24,22.51Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.73a4 4 0 013.7-3.7l1.81-1.82a6 6 0 00-7.33 7.33zM30.94 15.66A16.4 16.4 0 0025.2 8.22L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.1A15.29 15.29 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM20 16a4 4 0 01-6 3.44L19.44 14A4 4 0 0120 16zm-4 9a13.05 13.05 0 01-6-1.58l2.54-2.54a6 6 0 008.35-8.35l2.87-2.87A14.54 14.54 0 0128.93 16C26.9 21.07 21.3 25 16 25z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewOff.propTypes = iconPropTypes;
}
const ViewOffFilled = /*#__PURE__*/React.forwardRef(function ViewOffFilled(_ref5, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94 15.66a16.4 16.4 0 00-5.73-7.45L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.09A15.38 15.38 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM16 22.5a6.46 6.46 0 01-3.83-1.26L14 19.43A4 4 0 0019.43 14l1.81-1.81A6.49 6.49 0 0116 22.5zM4.53 21.81l5-5A6.84 6.84 0 019.5 16 6.51 6.51 0 0116 9.5a6.84 6.84 0 01.79.05l3.78-3.77A14.39 14.39 0 0016 5 16.69 16.69 0 001.06 15.66a1 1 0 000 .68A15.86 15.86 0 004.53 21.81z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewOffFilled.propTypes = iconPropTypes;
}
const ViewNext = /*#__PURE__*/React.forwardRef(function ViewNext(_ref6, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref6;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.587 22L15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewNext.propTypes = iconPropTypes;
}
const VirtualColumn = /*#__PURE__*/React.forwardRef(function VirtualColumn(_ref7, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref7;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28H20a2.0023 2.0023 0 01-2-2V6a2.0023 2.0023 0 012-2H30V6H20V26H30zM12 28H2V26H12V6H2V4H12a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualColumn.propTypes = iconPropTypes;
}
const VirtualColumnKey = /*#__PURE__*/React.forwardRef(function VirtualColumnKey(_ref8, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref8;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "9.5",
    r: "1.5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualColumnKey.propTypes = iconPropTypes;
}
const VirtualDesktop = /*#__PURE__*/React.forwardRef(function VirtualDesktop(_ref9, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref9;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21,16H11a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h4v2H12v2h8V28H17V26h4a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,21,16ZM11,24V18H21l.0015,6Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8218,10.124a9.9992,9.9992,0,0,0-19.6436,0A7.4914,7.4914,0,0,0,7,24.9746v-2a5.4945,5.4945,0,0,1,.123-10.9541l.8365-.0566.09-.834a7.9979,7.9979,0,0,1,15.9014,0l.09.834.8365.0566A5.4945,5.4945,0,0,1,25,22.9746v2a7.4914,7.4914,0,0,0,.8218-14.8506Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualDesktop.propTypes = iconPropTypes;
}
const VirtualMachine = /*#__PURE__*/React.forwardRef(function VirtualMachine(_ref10, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref10;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualMachine.propTypes = iconPropTypes;
}
const VirtualPrivateCloud = /*#__PURE__*/React.forwardRef(function VirtualPrivateCloud(_ref11, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref11;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualPrivateCloud.propTypes = iconPropTypes;
}
const VirtualPrivateCloudAlt = /*#__PURE__*/React.forwardRef(function VirtualPrivateCloudAlt(_ref12, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref12;
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["VirtualPrivateCloudAlt"]) {
      didWarnAboutDeprecation["VirtualPrivateCloudAlt"] = true;
      console.warn("Icon name was requested by the product team to be renamed to and replaced by ibm-cloud--vpc. As a result, the VirtualPrivateCloudAlt component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6a3.9915 3.9915 0 00-7.8579-1H13V7h9.1421A3.9945 3.9945 0 0025 9.8579V19h2V9.8579A3.9962 3.9962 0 0030 6zM26 8a2 2 0 112-2A2.0023 2.0023 0 0126 8zM19 25H9.8579A3.9945 3.9945 0 007 22.1421V13H5v9.1421A3.9915 3.9915 0 109.8579 27H19zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualPrivateCloudAlt.propTypes = iconPropTypes;
}
const VisualRecognition = /*#__PURE__*/React.forwardRef(function VisualRecognition(_ref13, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref13;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VisualRecognition.propTypes = iconPropTypes;
}
const Vlan = /*#__PURE__*/React.forwardRef(function Vlan(_ref14, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref14;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30,17V15H17V11h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.0023,2.0023,0,0,0-2,2V9a2.0023,2.0023,0,0,0,2,2h2v4H2v2H8v4H6a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H10V17H22v4H20a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H24V17ZM13,4h6V9H13ZM12,28H6V23h6Zm14,0H20V23h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Vlan.propTypes = iconPropTypes;
}
const VlanIbm = /*#__PURE__*/React.forwardRef(function VlanIbm(_ref15, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref15;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22a4 4 0 104 4A4.0045 4.0045 0 0016 22zm0 6a2 2 0 112-2A2.002 2.002 0 0116 28zM30 5a3 3 0 10-4 2.8154V15H17V9H15v6H6V7.8159a3.0007 3.0007 0 10-2 0V15a2.002 2.002 0 002 2h9v3h2V17h9a2.002 2.002 0 002-2V7.8159A2.9958 2.9958 0 0030 5zM5 4A1 1 0 114 5 1.0013 1.0013 0 015 4zM27 6a1 1 0 111-1A1.0013 1.0013 0 0127 6z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "5",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VlanIbm.propTypes = iconPropTypes;
}
const VmdkDisk = /*#__PURE__*/React.forwardRef(function VmdkDisk(_ref16, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref16;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "24.5",
    r: "1.5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.964H21.5V20.035H19.5z",
    transform: "rotate(-45 20.5 17.5)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VmdkDisk.propTypes = iconPropTypes;
}
const VoiceActivate = /*#__PURE__*/React.forwardRef(function VoiceActivate(_ref17, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref17;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H23V14H19zM9.3325 25.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VoiceActivate.propTypes = iconPropTypes;
}
const Voicemail = /*#__PURE__*/React.forwardRef(function Voicemail(_ref18, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref18;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Voicemail.propTypes = iconPropTypes;
}
const VolumeBlockStorage = /*#__PURE__*/React.forwardRef(function VolumeBlockStorage(_ref19, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref19;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21H10V14h7zm-5-2h3V16H12zM17 30H10V23h7zm-5-2h3V25H12zM26 21H19V14h7zm-5-2h3V16H21zM26 30H19V23h7zm-5-2h3V25H21z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeBlockStorage.propTypes = iconPropTypes;
}
const VolumeDown = /*#__PURE__*/React.forwardRef(function VolumeDown(_ref20, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref20;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30zM6 20h6a1.17 1.17 0 01.79.3L19 26.57V5.43L12.79 11.7A1.17 1.17 0 0112 12H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeDown.propTypes = iconPropTypes;
}
const VolumeDownAlt = /*#__PURE__*/React.forwardRef(function VolumeDownAlt(_ref21, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref21;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeDownAlt.propTypes = iconPropTypes;
}
const VolumeDownFilled = /*#__PURE__*/React.forwardRef(function VolumeDownFilled(_ref22, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref22;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeDownFilled.propTypes = iconPropTypes;
}
const VolumeDownFilledAlt = /*#__PURE__*/React.forwardRef(function VolumeDownFilledAlt(_ref23, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref23;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeDownFilledAlt.propTypes = iconPropTypes;
}
const VolumeFileStorage = /*#__PURE__*/React.forwardRef(function VolumeFileStorage(_ref24, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref24;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707,17.293l-5-5A1,1,0,0,0,20,12H14a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V18A1,1,0,0,0,25.707,17.293ZM23.5857,18H20V14.4141ZM14,28V14h4v4a2,2,0,0,0,2,2h4v8Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8,27H4a2.0023,2.0023,0,0,1-2-2V5A2.0023,2.0023,0,0,1,4,3h7.5857A1.9865,1.9865,0,0,1,13,3.5859L16.4143,7H28a2.0023,2.0023,0,0,1,2,2v8H28V9H15.5857l-4-4H4V25H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeFileStorage.propTypes = iconPropTypes;
}
const VolumeMute = /*#__PURE__*/React.forwardRef(function VolumeMute(_ref25, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref25;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6a1.17 1.17 0 01.79.3L17 26.57V5.43L10.79 11.7A1.17 1.17 0 0110 12H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeMute.propTypes = iconPropTypes;
}
const VolumeMuteFilled = /*#__PURE__*/React.forwardRef(function VolumeMuteFilled(_ref26, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref26;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeMuteFilled.propTypes = iconPropTypes;
}
const VolumeObjectStorage = /*#__PURE__*/React.forwardRef(function VolumeObjectStorage(_ref27, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref27;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23,24a2.98,2.98,0,0,0-2.0376.8115l-4.0037-2.4023a2.0478,2.0478,0,0,0,0-.8184l4.0037-2.4023a3.2463,3.2463,0,1,0-.9211-1.7793l-4.0037,2.4023a3,3,0,1,0,0,4.377l4.0037,2.4023A2.9729,2.9729,0,0,0,20,27a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0008,1.0008,0,0,1,23,16Zm-9,7a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,14,23Zm9,5a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,23,28Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeObjectStorage.propTypes = iconPropTypes;
}
const VolumeUp = /*#__PURE__*/React.forwardRef(function VolumeUp(_ref28, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref28;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6.08a1 1 0 01.71.3L17 26.57V5.43L10.79 11.7a1 1 0 01-.71.3H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeUp.propTypes = iconPropTypes;
}
const VolumeUpAlt = /*#__PURE__*/React.forwardRef(function VolumeUpAlt(_ref29, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref29;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeUpAlt.propTypes = iconPropTypes;
}
const VolumeUpFilled = /*#__PURE__*/React.forwardRef(function VolumeUpFilled(_ref30, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref30;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeUpFilled.propTypes = iconPropTypes;
}
const VolumeUpFilledAlt = /*#__PURE__*/React.forwardRef(function VolumeUpFilledAlt(_ref31, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref31;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeUpFilledAlt.propTypes = iconPropTypes;
}
const Vpn = /*#__PURE__*/React.forwardRef(function Vpn(_ref32, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref32;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM28 19L24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19zM8 9L6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Vpn.propTypes = iconPropTypes;
}
const VpnConnection = /*#__PURE__*/React.forwardRef(function VpnConnection(_ref33, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref33;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28,7a1.9919,1.9919,0,0,0-1.7227,1H22A6,6,0,0,0,10,8H5.7227a2,2,0,1,0,0,2H10v4H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2H22V10h4.2773A1.9966,1.9966,0,1,0,28,7ZM12,8a4,4,0,0,1,8,0v6H12V10h5V8Zm12,8V28H8V16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VpnConnection.propTypes = iconPropTypes;
}
const VpnPolicy = /*#__PURE__*/React.forwardRef(function VpnPolicy(_ref34, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref34;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15A6,6,0,1,0,20,19.46V29l4-1.8838L28,29V19.46A5.98,5.98,0,0,0,30,15ZM26,25.8477l-2-.9415-2,.9415V20.65a5.8877,5.8877,0,0,0,4,0ZM24,19a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,19Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M14,2A6.0066,6.0066,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H17V28H6V16h9V14H10V8a4,4,0,0,1,7.92-.8008l1.96-.3984A6.0167,6.0167,0,0,0,14,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VpnPolicy.propTypes = iconPropTypes;
}
const Wallet = /*#__PURE__*/React.forwardRef(function Wallet(_ref35, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref35;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17H24V19H22z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H4V5H26V3H4A2,2,0,0,0,2,5V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM4,26V10H28v3H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8v3ZM28,15v6H20V15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Wallet.propTypes = iconPropTypes;
}
const Warning = /*#__PURE__*/React.forwardRef(function Warning(_ref36, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref36;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
    })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 4H8.5V9H7.5zM8 10.2c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8S8.4 10.2 8 10.2z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H17V19H15zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Warning.propTypes = iconPropTypes;
}
const WarningAlt = /*#__PURE__*/React.forwardRef(function WarningAlt(_ref37, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref37;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
      d: "M14.5,14h-13c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.3,0-0.5l6.5-12C7.7,1,8,0.9,8.2,1.1c0.1,0,0.2,0.1,0.2,0.2l6.5,12 c0.1,0.2,0.1,0.3,0,0.5C14.9,13.9,14.7,14,14.5,14z M2.3,13h11.3L8,2.5L2.3,13z"
    })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 6H8.5V9.5H7.5zM8 10.8c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8S8.4 10.8 8 10.8z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 23zM15 12H17V21H15z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningAlt.propTypes = iconPropTypes;
}
const WarningAltFilled = /*#__PURE__*/React.forwardRef(function WarningAltFilled(_ref38, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref38;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Zm-1.125-5h2.25V12h-2.25Z",
    "data-icon-path": "inner-path"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M16.002,6.1714h-.004L4.6487,27.9966,4.6506,28H27.3494l.0019-.0034ZM14.875,12h2.25v9h-2.25ZM16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningAltFilled.propTypes = iconPropTypes;
}
const WarningAltInverted = /*#__PURE__*/React.forwardRef(function WarningAltInverted(_ref39, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref39;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 17zM15 6H17V15H15z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningAltInverted.propTypes = iconPropTypes;
}
const WarningAltInvertedFilled = /*#__PURE__*/React.forwardRef(function WarningAltInvertedFilled(_ref40, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref40;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Zm-1.125-5h2.25V6h-2.25Z",
    "data-icon-path": "inner-path"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3494,4H4.6506l-.0019.0034L15.998,25.8286h.004L27.3513,4.0034ZM14.875,6h2.25v9h-2.25ZM16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningAltInvertedFilled.propTypes = iconPropTypes;
}
const WarningDiamond = /*#__PURE__*/React.forwardRef(function WarningDiamond(_ref41, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref41;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5h0zM15 9H17V18H15z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m16,30c-.5335,0-1.0672-.2031-1.4732-.6094L2.6094,17.4732c-.8126-.8123-.8126-2.1342,0-2.9465L14.5268,2.6094c.8121-.8126,2.1344-.8126,2.9465,0l11.9173,11.9173c.8126.8123.8126,2.1342,0,2.9465l-11.9173,11.9173c-.406.4063-.9398.6094-1.4732.6094Zm0-26.0008c-.0215,0-.0427.0083-.0591.0244L4.0236,15.9409c-.0325.0327-.0325.0855,0,.1182l11.9173,11.9173c.0327.0322.0855.0322.1182,0l11.9173-11.9173c.0325-.0327.0325-.0855,0-.1182l-11.9173-11.9173c-.0164-.0161-.0376-.0244-.0591-.0244Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningDiamond.propTypes = iconPropTypes;
}
const WarningFilled = /*#__PURE__*/React.forwardRef(function WarningFilled(_ref42, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref42;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.2,1,1,4.2,1,8s3.2,7,7,7s7-3.1,7-7S11.9,1,8,1z M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2 c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z"
    })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8 c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
      d: "M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1 s1,0.4,1,1S10.6,16,10,16z"
    })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
      d: "M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,16,10,16z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
      d: "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11C23,5.9,18.1,1,12,1z M11.1,6h1.8v8h-1.8V6z M12,19.2 c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S12.7,19.2,12,19.2z"
    })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M13.2,18c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2S13.2,17.3,13.2,18z M12.9,6 h-1.8v8h1.8V6z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14C30,8.3,23.7,2,16,2z M14.9,8h2.2v11h-2.2V8z M16,25 c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22c0.8,0,1.5,0.7,1.5,1.5S16.8,25,16,25z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M17.5,23.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22 C16.8,22,17.5,22.7,17.5,23.5z M17.1,8h-2.2v11h2.2V8z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningFilled.propTypes = iconPropTypes;
}
const WarningHex = /*#__PURE__*/React.forwardRef(function WarningHex(_ref43, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref43;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 21zM15 8H17V18H15z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M23,29H9a1,1,0,0,1-.8638-.4961l-7-12a1,1,0,0,1,0-1.0078l7-12A1,1,0,0,1,9,3H23a1,1,0,0,1,.8638.4961l7,12a1,1,0,0,1,0,1.0078l-7,12A1,1,0,0,1,23,29ZM9.5742,27H22.4258l6.4165-11L22.4258,5H9.5742L3.1577,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningHex.propTypes = iconPropTypes;
}
const WarningHexFilled = /*#__PURE__*/React.forwardRef(function WarningHexFilled(_ref44, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref44;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z",
    "data-icon-path": "inner-path"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8508,15.4487,23.8867,3.5322A1.0687,1.0687,0,0,0,22.9643,3H9.0357a1.0687,1.0687,0,0,0-.9224.5322L1.1492,15.4487a1.0933,1.0933,0,0,0,0,1.1026L8.1133,28.4678A1.0687,1.0687,0,0,0,9.0357,29H22.9643a1.0687,1.0687,0,0,0,.9224-.5322l6.9641-11.9165A1.0933,1.0933,0,0,0,30.8508,15.4487ZM14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningHexFilled.propTypes = iconPropTypes;
}
const WarningMultiple = /*#__PURE__*/React.forwardRef(function WarningMultiple(_ref45, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref45;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m29,23h-4v-2h2.3821l-7.8821-15.7639-1.1055,2.2112-1.7891-.8945,2-4c.1694-.3387.532-.5527.8945-.5527s.7251.214.8945.5527l9.5,19c.1548.3101.1384.6782-.0439.973-.1821.2948-.5039.4742-.8506.4742Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "25",
    r: "1.25"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H15V22H13z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m25,30H3c-.3499,0-.6743-.1829-.8555-.4823s-.1926-.6718-.0303-.9817L13.1143,7.536c.1726-.3296.5292-.536.8857-.536s.7131.2064.8857.536l11,21c.1624.3099.1509.6823-.0303.9817s-.5056.4823-.8555.4823Zm-20.3474-2h18.6948L14,10.1552,4.6526,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningMultiple.propTypes = iconPropTypes;
}
const WarningOther = /*#__PURE__*/React.forwardRef(function WarningOther(_ref46, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref46;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H30V22H18zM18 24H30V26H18zM18 28H30V30H18zM14 18a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0014 18zM13 7H15V16H13z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4A10.0111,10.0111,0,0,1,24,14h2A12,12,0,1,0,14,26V24A10,10,0,0,1,14,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningOther.propTypes = iconPropTypes;
}
const WarningSquare = /*#__PURE__*/React.forwardRef(function WarningSquare(_ref47, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref47;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 20zM15 9H17V18H15z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningSquare.propTypes = iconPropTypes;
}
const WarningSquareFilled = /*#__PURE__*/React.forwardRef(function WarningSquareFilled(_ref48, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref48;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0022,4H5.998A1.998,1.998,0,0,0,4,5.998V26.002A1.998,1.998,0,0,0,5.998,28H26.0022A1.9979,1.9979,0,0,0,28,26.002V5.998A1.9979,1.9979,0,0,0,26.0022,4ZM14.8752,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.8751,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WarningSquareFilled.propTypes = iconPropTypes;
}
const Watch = /*#__PURE__*/React.forwardRef(function Watch(_ref49, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref49;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8H21V2H19V8H13V2H11V8H10a2 2 0 00-2 2V22a2 2 0 002 2h1v6h2V24h6v6h2V24h1a2 2 0 002-2V10A2 2 0 0022 8zM10 22V10H22V22zM25 14H27V18H25z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Watch.propTypes = iconPropTypes;
}
const Watson = /*#__PURE__*/React.forwardRef(function Watson(_ref50, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref50;
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["Watson"]) {
      didWarnAboutDeprecation["Watson"] = true;
      console.warn("Icon represents the old avatar for the Watson brand, which is retired since the watsonx brand launch. Replaced by the icon watsonx. As a result, the Watson component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M21.74 9.49h0A11.41 11.41 0 0016 8h0a.76.76 0 100 1.51 10.15 10.15 0 011.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 00-2 4.44A9.58 9.58 0 017 17.22a3.43 3.43 0 01.28-2.66v0h0c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 00.74-.78.75.75 0 00-.78-.74C9.19 10.88 7.1 11.92 6 13.74H6v0s0 0 0 0a4.84 4.84 0 00-.44 3.79 12 12 0 003.2 5.22A11.36 11.36 0 008.52 26a10 10 0 01-2-3.48A.75.75 0 005.57 22a.76.76 0 00-.49 1 11.45 11.45 0 005.18 6.38h0A11.42 11.42 0 0016 30.92a11.74 11.74 0 003-.39 11.48 11.48 0 002.77-21zM18.58 29.06a9.9 9.9 0 01-7.56-1h0c-.86-.49-1.21-2-.94-4a18.85 18.85 0 002.48 1.72 13.92 13.92 0 006.93 2 11 11 0 002.42-.28A9.78 9.78 0 0118.58 29.06zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 01-2.89-2.12 21.08 21.08 0 012.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62h0A10 10 0 0124.64 24.4zM4.16 11.72L1.14 10a.76.76 0 10-.76 1.31L3.4 13a.86.86 0 00.38.1.77.77 0 00.66-.38A.76.76 0 004.16 11.72zM8.29 7.59A.74.74 0 008.94 8a.75.75 0 00.38-.1.76.76 0 00.28-1l-1.74-3a.76.76 0 00-1-.27.75.75 0 00-.28 1zM16 6.08a.76.76 0 00.76-.76V1.83a.76.76 0 00-1.52 0V5.32A.76.76 0 0016 6.08zM22.68 7.87a.75.75 0 001-.28l1.75-3a.75.75 0 00-.28-1 .76.76 0 00-1 .27l-1.74 3A.76.76 0 0022.68 7.87zM31.9 10.25a.76.76 0 00-1-.27l-3 1.74a.76.76 0 00-.28 1 .77.77 0 00.66.38.86.86 0 00.38-.1l3-1.75A.76.76 0 0031.9 10.25z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Watson.propTypes = iconPropTypes;
}
const WatsonMachineLearning = /*#__PURE__*/React.forwardRef(function WatsonMachineLearning(_ref51, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref51;
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["WatsonMachineLearning"]) {
      didWarnAboutDeprecation["WatsonMachineLearning"] = true;
      console.warn("Icon design is defunct, replaced with the existing icon ibm-watson--machine-learning. As a result, the WatsonMachineLearning component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26H20V17.76l-3.23 3.88a1 1 0 01-1.54 0L12 17.76V26H10V15a1 1 0 01.66-.94 1 1 0 011.11.3L16 19.44l4.23-5.08a1 1 0 011.11-.3A1 1 0 0122 15zM4.16 14.65l-3-1.75a.76.76 0 10-.76 1.32L3.4 16a.76.76 0 10.76-1.31zM8.29 10.52a.73.73 0 001 .27.75.75 0 00.28-1l-1.74-3a.76.76 0 10-1.32.76zM16 9a.76.76 0 00.76-.76V4.76a.76.76 0 10-1.52 0V8.25A.76.76 0 0016 9zM22.68 10.79a.75.75 0 00.37.11.76.76 0 00.66-.38l1.75-3a.76.76 0 00-1.32-.76l-1.74 3A.75.75 0 0022.68 10.79zM31.9 13.18a.76.76 0 00-1-.28l-3 1.75A.76.76 0 0028.6 16l3-1.74A.77.77 0 0031.9 13.18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonMachineLearning.propTypes = iconPropTypes;
}
const Watsonx = /*#__PURE__*/React.forwardRef(function Watsonx(_ref52, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref52;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29.312,22.9189c1.1042-2.1201,1.688-4.5127,1.688-6.9189C31,7.729,24.271,1,16,1c-3.3738,0-6.5815,1.1191-9.2046,3.1665-.2441-.106-.5125-.1665-.7954-.1665-1.1045,0-2,.8955-2,2s.8955,2,2,2,2-.8955,2-2c0-.0762-.0142-.1489-.0225-.2227,2.2812-1.7964,5.0793-2.7773,8.0225-2.7773.9727,0,1.9172.1157,2.8293.3193-3.3938.9258-5.8994,4.0273-5.8994,7.7109,0,.7891.1167,1.5503.332,2.27-.6985-.2021-1.4285-.3306-2.1919-.3306-3.7039,0-6.8191,2.5342-7.7256,5.957-.218-.9424-.3445-1.9189-.3445-2.9268,0-2.1162.4919-4.1328,1.4619-5.9951l-1.7739-.9238c-1.1042,2.1201-1.688,4.5127-1.688,6.9189,0,8.271,6.729,15,15,15,3.3738,0,6.5815-1.1191,9.2046-3.1665.2441.106.5125.1665.7954.1665,1.1045,0,2-.8955,2-2s-.8955-2-2-2-2,.8955-2,2c0,.0762.0142.1489.0225.2231-1.0796.8496-2.2776,1.5098-3.5493,1.9771.3315-.6641.5269-1.4072.5269-2.2002,0-1.6304-.7959-3.0669-2.0068-3.9805.0457-.3472.0769-.6978.0769-1.0498,0-.7856-.1257-1.54-.3381-2.2573.6995.2012,1.4346.3179,2.198.3179,3.7039,0,6.8191-2.5342,7.7256-5.957.218.9424.3445,1.9189.3445,2.9268,0,2.1162-.4919,4.1328-1.4619,5.9951l1.7739.9238Zm-17.7935,5.2646c-1.8389-.6807-3.49-1.7529-4.8325-3.1338-1.0366-1.1143-1.616-2.5527-1.616-4.0801,0-3.3081,2.6917-6,6-6s6,2.6919,6,6c0,.0498-.0125.0977-.0134.1475-.3413-.0737-.6936-.1172-1.0566-.1172-2.7571,0-5,2.2432-5,5,0,.7861.1924,1.5234.5186,2.1836Zm7.4814-2.1836c0,1.6543-1.3457,3-3,3s-3-1.3457-3-3,1.3457-3,3-3,3,1.3457,3,3Zm1.9299-8.9697c-3.3083,0-6-2.6919-6-6s2.6917-6,6-6c1.4294,0,2.7422.5039,3.7742,1.3418.3027.2739.5918.561.8677.8618.8479,1.0352,1.3582,2.3569,1.3582,3.7964,0,3.3081-2.6917,6-6,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Watsonx.propTypes = iconPropTypes;
}
const WatsonxAi = /*#__PURE__*/React.forwardRef(function WatsonxAi(_ref53, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref53;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m26,24c-1.1046,0-2,.8954-2,2,0,.0764.0142.1488.0225.2229-2.2808,1.7963-5.0792,2.7771-8.0225,2.7771-4.2617,0-8-3.9722-8-8.5,0-4.687,3.813-8.5,8.5-8.5h.5v-2h-.5c-5.7896,0-10.5,4.7104-10.5,10.5,0,1.8839.5304,3.6896,1.4371,5.2565-2.7133-2.3843-4.4371-5.869-4.4371-9.7565,0-2.1152.4917-4.1328,1.4619-5.9956l-1.7744-.9238c-1.104,2.1211-1.6875,4.5137-1.6875,6.9194,0,8.271,6.729,15,15,15,3.3744,0,6.5818-1.1193,9.2048-3.1662.244.106.5123.1662.7952.1662,1.1046,0,2-.8954,2-2s-.8954-2-2-2Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20H13V22H11z",
    transform: "rotate(90 12 21)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H21V12H19z",
    transform: "rotate(90 20 11)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-3.3744,0-6.5818,1.1193-9.2048,3.1662-.244-.106-.5123-.1662-.7952-.1662-1.1046,0-2,.8954-2,2s.8954,2,2,2,2-.8954,2-2c0-.0764-.0142-.1488-.0225-.2229,2.2808-1.7963,5.0792-2.7771,8.0225-2.7771,4.2617,0,8,3.9722,8,8.5,0,4.687-3.813,8.5-8.5,8.5h-.5v2h.5c5.7896,0,10.5-4.7104,10.5-10.5,0-1.8853-.5322-3.6917-1.4401-5.2593,2.715,2.3843,4.4401,5.8704,4.4401,9.7593,0,2.1152-.4917,4.1328-1.4619,5.9956l1.7744.9238c1.104-2.1211,1.6875-4.5137,1.6875-6.9194C31,7.729,24.271,1,16,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonxAi.propTypes = iconPropTypes;
}
const WatsonxData = /*#__PURE__*/React.forwardRef(function WatsonxData(_ref54, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref54;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m26,24c-1.1046,0-2,.8954-2,2,0,.0764.0142.1488.0225.2229-2.2808,1.7963-5.0792,2.7771-8.0225,2.7771-2.7746,0-5.3432-.881-7.4566-2.3676.2576.0261.517.0444.7798.0444,4.2329,0,7.6768-3.4438,7.6768-7.6768h-2c0,3.1304-2.5464,5.6768-5.6768,5.6768-2.2111,0-4.1977-1.2816-5.1318-3.2725-.1365-.2972-.2595-.6007-.3738-.9094.6602.322,1.3998.5051,2.1824.5051,2.7568,0,5-2.2432,5-5v-2h-2v2c0,1.6543-1.3457,3-3,3s-3-1.3457-3-3c0-2.1152.4917-4.1328,1.4619-5.9956l-1.7744-.9238c-1.104,2.1211-1.6875,4.5137-1.6875,6.9194,0,8.271,6.729,15,15,15,3.3744,0,6.5818-1.1193,9.2048-3.1662.244.106.5123.1662.7952.1662,1.1046,0,2-.8954,2-2s-.8954-2-2-2Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21H23V23H21z",
    transform: "rotate(90 22 22)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H17V17H15z",
    transform: "rotate(90 16 16)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9H11V11H9z",
    transform: "rotate(-90 10 10)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-3.3744,0-6.5818,1.1193-9.2048,3.1662-.244-.106-.5123-.1662-.7952-.1662-1.1046,0-2,.8954-2,2s.8954,2,2,2,2-.8954,2-2c0-.0764-.0142-.1488-.0225-.2229,2.2808-1.7963,5.0792-2.7771,8.0225-2.7771,2.7708,0,5.3363.8784,7.4481,2.3613-.249-.0242-.5005-.038-.7547-.038-4.2329,0-7.6768,3.4438-7.6768,7.6768h2c0-3.1304,2.5464-5.6768,5.6768-5.6768,2.0554,0,3.9068,1.0953,4.9186,2.8651.2153.4283.4053.8701.5729,1.3237-.6615-.3234-1.4005-.5121-2.1849-.5121-2.7568,0-5,2.2432-5,5v2h2v-2c0-1.6543,1.3457-3,3-3s3,1.3457,3,3c0,2.1152-.4917,4.1328-1.4619,5.9956l1.7744.9238c1.104-2.1211,1.6875-4.5137,1.6875-6.9194C31,7.729,24.271,1,16,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonxData.propTypes = iconPropTypes;
}
const WatsonxGovernance = /*#__PURE__*/React.forwardRef(function WatsonxGovernance(_ref55, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref55;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m26,24c-1.1046,0-2,.8954-2,2,0,.0764.0142.1488.0225.2229-2.2808,1.7963-5.0792,2.7771-8.0225,2.7771-7.1685,0-13-5.8315-13-13,0-2.1152.4917-4.1328,1.4619-5.9956l-1.7744-.9238c-1.104,2.1211-1.6875,4.5137-1.6875,6.9194,0,8.271,6.729,15,15,15,3.3744,0,6.5818-1.1193,9.2048-3.1662.244.106.5123.1662.7952.1662,1.1046,0,2-.8954,2-2s-.8954-2-2-2Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23H13V25H11z",
    transform: "rotate(90 12 24)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9H13V11H11z",
    transform: "rotate(90 12 10)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16H13V18H11z",
    transform: "rotate(90 12 17)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-3.3744,0-6.5818,1.1193-9.2048,3.1662-.244-.106-.5123-.1662-.7952-.1662-1.1046,0-2,.8954-2,2s.8954,2,2,2,2-.8954,2-2c0-.0764-.0142-.1488-.0225-.2229,2.2808-1.7963,5.0792-2.7771,8.0225-2.7771,1.6543,0,3,1.3457,3,3s-1.3457,3-3,3h-1v2h1c2.7568,0,5-2.2432,5-5,0-.2399-.0203-.4748-.0531-.7057.9663,1.1348,1.5531,2.6021,1.5531,4.2057,0,3.584-2.916,6.5-6.5,6.5h-1v2h1c4.687,0,8.5-3.813,8.5-8.5,0-.7654-.1111-1.5036-.3017-2.2096,1.1321,1.6206,1.8017,3.587,1.8017,5.7096,0,5.5142-4.4858,10-10,10h-1v2h1c6.6167,0,12-5.3833,12-12,0-.8995-.1058-1.774-.2944-2.6176.8207,1.7031,1.2944,3.6038,1.2944,5.6176,0,2.1152-.4917,4.1328-1.4619,5.9956l1.7744.9238c1.104-2.1211,1.6875-4.5137,1.6875-6.9194C31,7.729,24.271,1,16,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonxGovernance.propTypes = iconPropTypes;
}
const WaveDirection = /*#__PURE__*/React.forwardRef(function WaveDirection(_ref56, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref56;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7126,6.7126,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0962,10.0962,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M18,24V22a8,8,0,1,0-8-8H8A10,10,0,1,1,18,24Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "8",
    r: "1"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.5859l-2.3-2.3007A2.9665,2.9665,0,0,0,21,14a3.0033,3.0033,0,0,0-3-3,2.9609,2.9609,0,0,0-1.2854.3008L14.4141,9,13,10.4141l2.3,2.3007A2.9665,2.9665,0,0,0,15,14a3.0033,3.0033,0,0,0,3,3,2.9609,2.9609,0,0,0,1.2854-.3008L21.5859,19ZM17,14a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,17,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WaveDirection.propTypes = iconPropTypes;
}
const WaveHeight = /*#__PURE__*/React.forwardRef(function WaveHeight(_ref57, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref57;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2H30V4H24zM24 8H28V10H24zM24 14H30V16H24zM24 20H28V22H24z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28H24a10.0349,10.0349,0,0,1-6.9268-17.2622A11.9629,11.9629,0,0,0,12.9937,10a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,16.4348,4,21.34,4,28H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,8h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,26h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WaveHeight.propTypes = iconPropTypes;
}
const WavePeriod = /*#__PURE__*/React.forwardRef(function WavePeriod(_ref58, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref58;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H17a7.0078 7.0078 0 01-7-7 6.6832 6.6832 0 012.0244-4.6967A6.7935 6.7935 0 0010.0093 18C5.0425 18.0466 4 24.5513 4 30H2C2 18.4907 6.3452 16.0342 9.9907 16a10.0717 10.0717 0 014.4785 1.117 1 1 0 01.0616 1.73A4.8773 4.8773 0 0017 28h5zM17 8H19V16H17z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5.4141,26.5859,4,24.3242,6.2617A9.95,9.95,0,0,0,19,4.0508V2H17V4.0508A10.0132,10.0132,0,0,0,8,14h2a8,8,0,1,1,8,8v2A9.9928,9.9928,0,0,0,25.7383,7.6758Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WavePeriod.propTypes = iconPropTypes;
}
const WeatherFrontCold = /*#__PURE__*/React.forwardRef(function WeatherFrontCold(_ref59, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref59;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WeatherFrontCold.propTypes = iconPropTypes;
}
const WeatherFrontStationary = /*#__PURE__*/React.forwardRef(function WeatherFrontStationary(_ref60, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref60;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a12.9848 12.9848 0 00-8.4074 3.1065A3.9947 3.9947 0 1015.583 11.728l-1.1362 4.1665c-.0725.2657-.1579.5254-.2489.7818a3.9864 3.9864 0 00-5.1547 6.0054A10.9541 10.9541 0 013.8345 24H2v2H3.8345c.2975 0 .5918-.0171.8853-.0371l7.9291 2.9736A1 1 0 0014 28V21.0923a12.9311 12.9311 0 00.9121-1.313l6.3628-1.8179a1 1 0 00.5059-1.5864L17.7843 11.38a10.9268 10.9268 0 011.1516-2.3472l5.7477 1.916A1 1 0 0026 10V4.2251A10.8956 10.8956 0 0128.1655 4H30V2zM17 6a1.98 1.98 0 011.3237.53A12.9413 12.9413 0 0016.24 9.8482 1.9988 1.9988 0 0117 6zM10 20a1.9879 1.9879 0 013.3374-1.4717 11.0157 11.0157 0 01-2.5959 3.0147A1.9975 1.9975 0 0110 20zM8.3354 25.1826A13.047 13.047 0 0012 23.0943v3.4624zm7.74-7.8154c.1107-.3105.2136-.625.3013-.9463l.732-2.6846L19.28 16.4512zM24 8.6123l-3.7411-1.247A11.0712 11.0712 0 0124 4.8306zM22 22L22 24 26.586 24 22 28.586 23.414 30 28 25.414 28 30 30 30 30 22 22 22zM2 2L2 4 6.586 4 2 8.586 3.414 10 8 5.414 8 10 10 10 10 2 2 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WeatherFrontStationary.propTypes = iconPropTypes;
}
const WeatherFrontWarm = /*#__PURE__*/React.forwardRef(function WeatherFrontWarm(_ref61, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref61;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1655 2a13.0289 13.0289 0 00-12.542 9.5791l-1.1767 4.3154A11.0237 11.0237 0 013.8345 24H2v2H3.8345a12.9139 12.9139 0 003.4687-.4819 3.9979 3.9979 0 106.5818-4.2866 12.9671 12.9671 0 001.6209-2.5269 3.9944 3.9944 0 102.3772-7.5991 10.95 10.95 0 011.7253-3.01 3.9825 3.9825 0 006.9058-3.9648A10.9435 10.9435 0 0128.1655 4H30V2zM11 26a1.9983 1.9983 0 01-1.8118-1.1655 13.0811 13.0811 0 003.2969-2.1426A1.9773 1.9773 0 0111 26zm8-11a1.9926 1.9926 0 01-2.759 1.8467c.0442-.1426.0959-.2813.1355-.4258L17.301 13.03A1.9976 1.9976 0 0119 15zm6-9a1.9942 1.9942 0 01-3.9011.5894 11.0511 11.0511 0 013.3623-1.9385A1.995 1.995 0 0125 6zM10 4L10 8.586 3.414 2 2 3.414 8.586 10 4 10 4 12 12 12 12 4 10 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WeatherFrontWarm.propTypes = iconPropTypes;
}
const WeatherStation = /*#__PURE__*/React.forwardRef(function WeatherStation(_ref62, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref62;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M17,28V17h1a2.0023,2.0023,0,0,0,2-2V11a2.0023,2.0023,0,0,0-2-2H14a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h1V28H2v2H30V28ZM14,11h4l.0015,4H14Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3325 18.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537zM22.667 18.2168l-1.334-1.49a4.9995 4.9995 0 000-7.4537l1.334-1.49a7 7 0 010 10.4341z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3994 21.8008a11.0019 11.0019 0 010-17.6006L7.6 5.8a9.0009 9.0009 0 000 14.4014zM25.6006 21.8008l-1.2012-1.6a9.001 9.001 0 000-14.4019l1.2012-1.6a11.002 11.002 0 010 17.6011z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WeatherStation.propTypes = iconPropTypes;
}
const WebServicesCluster = /*#__PURE__*/React.forwardRef(function WebServicesCluster(_ref63, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref63;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26c-.2559 0-.512-.0977-.707-.2928l-3-3c-.1953-.1953-.293-.4512-.293-.7071s.0977-.5118.293-.7072l3-3c.1951-.1952.451-.2928.707-.2928s.512.0977.707.2928l3 3c.1953.1953.293.4512.293.7071s-.0977.5118-.293.7072l-3 3c-.1951.1952-.4512.2928-.707.2928zm-1.5857-4l1.5857 1.5858 1.5857-1.5858-1.5857-1.5858-1.5857 1.5858zM22 20c-.2559 0-.512-.0977-.707-.2928l-3-3c-.1953-.1953-.293-.4512-.293-.7071s.0977-.5118.293-.7072l3-3c.1951-.1952.451-.2928.707-.2928s.512.0977.707.2928l3 3c.1953.1953.293.4512.293.7071s-.0977.5118-.293.7072l-3 3c-.1951.1952-.4512.2928-.707.2928zm-1.5857-4l1.5857 1.5858 1.5857-1.5858-1.5857-1.5858-1.5857 1.5858zM16 14c-.2559 0-.512-.0977-.707-.2928l-3-3c-.1953-.1953-.293-.4512-.293-.7071s.0977-.5118.293-.7072l3-3c.1951-.1952.451-.2928.707-.2928s.512.0977.707.2928l3 3c.1953.1953.293.4512.293.7071s-.0977.5118-.293.7072l-3 3c-.1951.1952-.4512.2928-.707.2928zm-1.5857-4l1.5857 1.5858 1.5857-1.5858-1.5857-1.5858-1.5857 1.5858zM10 20c-.2559 0-.512-.0977-.707-.2928l-3-3c-.1953-.1953-.293-.4512-.293-.7071s.0977-.5118.293-.7072l3-3c.1951-.1952.451-.2928.707-.2928s.512.0977.707.2928l3 3c.1953.1953.293.4512.293.7071s-.0977.5118-.293.7072l-3 3c-.1951.1952-.4512.2928-.707.2928zm-1.5857-4l1.5857 1.5858 1.5857-1.5858-1.5857-1.5858-1.5857 1.5858z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.1741,0-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5081-.4961.8638v14c0,.3557.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l11-6.4166-1.0078-1.7275-10.4961,6.1227-11-6.4166v-12.8513L16,3.1577l11,6.4166v7.4257h2v-8c0-.3557-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WebServicesCluster.propTypes = iconPropTypes;
}
const WebServicesContainer = /*#__PURE__*/React.forwardRef(function WebServicesContainer(_ref64, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref64;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5046,11.6367l-5.9883-3.5c-.1594-.0933-.3381-.1387-.5164-.1367-.1699.002-.3394.0474-.4915.1357l-6.0117,3.5c-.3076.1792-.4968.5083-.4968.8643v7c0,.356.1892.6851.4968.8643l6.0117,3.5c.1555.0903.3176.1357.4915.1357.1743,0,.3604-.0454.5164-.1367l5.9883-3.5c.3069-.1792.4954-.5078.4954-.8633v-7c0-.3555-.1885-.6841-.4954-.8633Zm-6.4939-1.479l4.0076,2.3423-4.0076,2.3423-4.0232-2.3423,4.0232-2.3423Zm-5.0107,4.0815l4,2.3291v4.6855l-4-2.3291v-4.6855Zm6,7.0249v-4.6836l4-2.3379v4.6836l-4,2.3379Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.1741,0-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5081-.4961.8638v14c0,.3557.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l11-6.4166-1.0078-1.7275-10.4961,6.1227-11-6.4166v-12.8513L16,3.1577l11,6.4166v7.4257h2v-8c0-.3557-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WebServicesContainer.propTypes = iconPropTypes;
}
const WebServicesDefinition = /*#__PURE__*/React.forwardRef(function WebServicesDefinition(_ref65, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref65;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17H16V19H14zM14 13H18V15H14z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m21,23h-10c-.5522,0-1-.4478-1-1v-12c0-.5522.4478-1,1-1h10c.5522,0,1,.4478,1,1v12c0,.5522-.4478,1-1,1Zm-9-2h8v-10h-8v10Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.1741,0-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5081-.4961.8638v14c0,.3557.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l11-6.4166-1.0078-1.7275-10.4961,6.1227-11-6.4166v-12.8513L16,3.1577l11,6.4166v7.4257h2v-8c0-.3557-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WebServicesDefinition.propTypes = iconPropTypes;
}
const WebServicesService = /*#__PURE__*/React.forwardRef(function WebServicesService(_ref66, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref66;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "m23,18h-2v-7h-7v-2h8c.5522,0,1,.4478,1,1v8Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m18,23h-8c-.5522,0-1-.4478-1-1v-8c0-.5522.4478-1,1-1h8c.5522,0,1,.4478,1,1v8c0,.5522-.4478,1-1,1Zm-7-2h6v-6h-6v6Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.1741,0-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5081-.4961.8638v14c0,.3557.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l11-6.4166-1.0078-1.7275-10.4961,6.1227-11-6.4166v-12.8513L16,3.1577l11,6.4166v7.4257h2v-8c0-.3557-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WebServicesService.propTypes = iconPropTypes;
}
const WebServicesTask = /*#__PURE__*/React.forwardRef(function WebServicesTask(_ref67, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref67;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.18L18.41 18.59 17 20 20 23 25 18 23.59 16.59 20 20.18z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m15,23h-4c-.5522,0-1-.4478-1-1v-12c0-.5522.4478-1,1-1h10c.5522,0,1,.4478,1,1v6h-2v-5h-8v10h3v2Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.1741,0-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5081-.4961.8638v14c0,.3557.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l11-6.4166-1.0078-1.7275-10.4961,6.1227-11-6.4166v-12.8513L16,3.1577l11,6.4166v7.4257h2v-8c0-.3557-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WebServicesTask.propTypes = iconPropTypes;
}
const WebServicesTaskDefinitionVersion = /*#__PURE__*/React.forwardRef(function WebServicesTaskDefinitionVersion(_ref68, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref68;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15L22.25 15 20 22.0312 17.7917 15.0003 16 15.0003 18.5 23 21.5 23 24 15z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m16,23h-5c-.5522,0-1-.4478-1-1v-12c0-.5522.4478-1,1-1h10c.5522,0,1,.4478,1,1v4h-2v-3h-8v10h4v2Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1c-.1741,0-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5081-.4961.8638v14c0,.3557.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l11-6.4166-1.0078-1.7275-10.4961,6.1227-11-6.4166v-12.8513L16,3.1577l11,6.4166v7.4257h2v-8c0-.3557-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WebServicesTaskDefinitionVersion.propTypes = iconPropTypes;
}
const Webhook = /*#__PURE__*/React.forwardRef(function Webhook(_ref69, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref69;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26a3,3,0,1,0-2.8164-4H13v1a5,5,0,1,1-5-5V16a7,7,0,1,0,6.9287,8h6.2549A2.9914,2.9914,0,0,0,24,26Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M24,16a7.024,7.024,0,0,0-2.57.4873l-3.1656-5.5395a3.0469,3.0469,0,1,0-1.7326.9985l4.1189,7.2085.8686-.4976a5.0006,5.0006,0,1,1-1.851,6.8418L17.937,26.501A7.0005,7.0005,0,1,0,24,16Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M8.532,20.0537a3.03,3.03,0,1,0,1.7326.9985C11.74,18.47,13.86,14.7607,13.89,14.708l.4976-.8682-.8677-.497a5,5,0,1,1,6.812-1.8438l1.7315,1.002a7.0008,7.0008,0,1,0-10.3462,2.0356c-.457.7427-1.1021,1.8716-2.0737,3.5728Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Webhook.propTypes = iconPropTypes;
}
const Websheet = /*#__PURE__*/React.forwardRef(function Websheet(_ref70, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref70;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "2"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Websheet.propTypes = iconPropTypes;
}
const Wheat = /*#__PURE__*/React.forwardRef(function Wheat(_ref71, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref71;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M21,3V5.5857l-4,4V1H15V9.5857l-4-4V3H9V19a7.004,7.004,0,0,0,6,6.92V30h2V25.92A7.004,7.004,0,0,0,23,19V3ZM15,23.8987A5.008,5.008,0,0,1,11,19v-2.586l4,4Zm0-6.313-4-4V8.4138l4,4Zm2-5.1719,4-4v5.1719l-4,4Zm0,11.4849V20.4138l4-4V19A5.008,5.008,0,0,1,17,23.8987Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Wheat.propTypes = iconPropTypes;
}
const WhitePaper = /*#__PURE__*/React.forwardRef(function WhitePaper(_ref72, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref72;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27.1798L19.41 24.5899 18 26 22 30 30 22 28.5899 20.59 22 27.1798zM9 17H16V19H9zM9 12H21V14H9zM9 7H21V9H9z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m16,30H6c-1.103,0-2-.8972-2-2V4c0-1.1028.897-2,2-2h18c1.103,0,2,.8972,2,2v15h-2V4H6v24h10v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WhitePaper.propTypes = iconPropTypes;
}
const Wifi = /*#__PURE__*/React.forwardRef(function Wifi(_ref73, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref73;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "2"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M10.47,19.2334l1.4136,1.4131a5.9688,5.9688,0,0,1,8.2229-.0093L21.52,19.2236a7.9629,7.9629,0,0,0-11.05.01Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M6.229,14.9927l1.4136,1.4135a11.955,11.955,0,0,1,16.7041-.01L25.76,14.9829a13.9514,13.9514,0,0,0-19.5313.01Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10.7412a19.94,19.94,0,0,0-28,0v.0225L3.4043,12.168a17.9336,17.9336,0,0,1,25.1811-.01L30,10.7432Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Wifi.propTypes = iconPropTypes;
}
const WifiController = /*#__PURE__*/React.forwardRef(function WifiController(_ref74, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref74;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "25",
    r: "1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14.5",
    r: "1.5"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7832,10.3325a7.0007,7.0007,0,0,1,10.4341,0l-1.49,1.334a5,5,0,0,0-7.4537,0Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1992,7.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,8.6a9.0009,9.0009,0,0,0-14.4014.0005Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WifiController.propTypes = iconPropTypes;
}
const WifiNotSecure = /*#__PURE__*/React.forwardRef(function WifiNotSecure(_ref75, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref75;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H14V17a2 2 0 014 0h2a4 4 0 00-8 0v3a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h8a2.0025 2.0025 0 002-2V22A2.0025 2.0025 0 0020 20zm0 8H12V22h8zM16 8a8.9709 8.9709 0 00-6.3608 2.6392l1.4133 1.4135a6.9887 6.9887 0 019.895 0l1.4135-1.4135A8.9717 8.9717 0 0016 8z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M6.105,7.105,7.5188,8.5186a11.9808,11.9808,0,0,1,16.9624,0L25.8949,7.105a13.9782,13.9782,0,0,0-19.79,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WifiNotSecure.propTypes = iconPropTypes;
}
const WifiOff = /*#__PURE__*/React.forwardRef(function WifiOff(_ref76, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref76;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "2"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.4141L28.5859 2 2 28.5859 3.4141 30 14.0962 19.3179a5.9359 5.9359 0 016.01 1.3193L21.52 19.2236a7.9669 7.9669 0 00-5.125-2.2041l3.3875-3.3877a11.9908 11.9908 0 014.5647 2.7647L25.76 14.9829A13.975 13.975 0 0021.334 12.08L24.3308 9.083a17.9364 17.9364 0 014.2546 3.0747L30 10.7432v-.002a20.02 20.02 0 00-4.1895-3.1377zM14.68 13.0776l2.0415-2.0415C16.481 11.0234 16.2437 11 16 11a13.9447 13.9447 0 00-9.771 3.9927l1.4136 1.4136A11.97 11.97 0 0114.68 13.0776zM16 7a17.87 17.87 0 014.2324.5254L21.875 5.8828A19.9537 19.9537 0 002 10.7412v.0225L3.4043 12.168A17.9193 17.9193 0 0116 7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WifiOff.propTypes = iconPropTypes;
}
const WifiSecure = /*#__PURE__*/React.forwardRef(function WifiSecure(_ref77, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref77;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20V17a4 4 0 00-8 0v3a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h8a2.0025 2.0025 0 002-2V22A2.0025 2.0025 0 0020 20zm-6-3a2 2 0 014 0v3H14zM12 28V22h8v6zM6.105 7.105L7.5188 8.5186a11.9808 11.9808 0 0116.9624 0L25.8949 7.105a13.9782 13.9782 0 00-19.79 0z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a8.9709,8.9709,0,0,0-6.3608,2.6392l1.4133,1.4135a6.9887,6.9887,0,0,1,9.895,0l1.4135-1.4135A8.9717,8.9717,0,0,0,16,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WifiSecure.propTypes = iconPropTypes;
}
const WifiBridge = /*#__PURE__*/React.forwardRef(function WifiBridge(_ref78, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref78;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9492,20.95l-1.414-1.4141a5,5,0,0,0,0-7.0715L6.9492,11.05a7,7,0,0,1,0,9.9Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4854 24.4854L9.0713 23.0713a10.0011 10.0011 0 000-14.1426l1.4141-1.4141a12.0006 12.0006 0 010 16.9708zM25.0508 20.95a7 7 0 010-9.9l1.414 1.4146a5 5 0 000 7.0715z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5146 24.4854a12.0006 12.0006 0 010-16.9708l1.4141 1.4141a10.0011 10.0011 0 000 14.1426zM3 15H2V4H0V28H2V17H3a1 1 0 000-2zM30 4V15H29a1 1 0 000 2h1V28h2V4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WifiBridge.propTypes = iconPropTypes;
}
const WifiBridgeAlt = /*#__PURE__*/React.forwardRef(function WifiBridgeAlt(_ref79, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref79;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M13,26H11a5.0057,5.0057,0,0,0-5-5V19A7.0078,7.0078,0,0,1,13,26Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26H16A10.0113 10.0113 0 006 16V14A12.0137 12.0137 0 0118 26zM26 13a7.0078 7.0078 0 01-7-7h2a5.0057 5.0057 0 005 5z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18A12.0137 12.0137 0 0114 6h2A10.0113 10.0113 0 0026 16zM7.707 24.293a.9994.9994 0 00-1.414 0L2 28.5859 3.4143 30 7.707 25.707A.9994.9994 0 007.707 24.293zM28.5859 2L24.293 6.293a1 1 0 001.414 1.414L30 3.4141z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WifiBridgeAlt.propTypes = iconPropTypes;
}
const Wikis = /*#__PURE__*/React.forwardRef(function Wikis(_ref80, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref80;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM28,15H22A24.26,24.26,0,0,0,19.21,4.45,12,12,0,0,1,28,15ZM16,28a5,5,0,0,1-.67,0A21.85,21.85,0,0,1,12,17H20a21.85,21.85,0,0,1-3.3,11A5,5,0,0,1,16,28ZM12,15a21.85,21.85,0,0,1,3.3-11,6,6,0,0,1,1.34,0A21.85,21.85,0,0,1,20,15Zm.76-10.55A24.26,24.26,0,0,0,10,15h-6A12,12,0,0,1,12.79,4.45ZM4.05,17h6a24.26,24.26,0,0,0,2.75,10.55A12,12,0,0,1,4.05,17ZM19.21,27.55A24.26,24.26,0,0,0,22,17h6A12,12,0,0,1,19.21,27.55Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Wikis.propTypes = iconPropTypes;
}
const WindGusts = /*#__PURE__*/React.forwardRef(function WindGusts(_ref81, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref81;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3164,8.0513l-18-6A1,1,0,0,0,10.4,2.2L4,7V2H2V30H4V11l6.4,4.8a1,1,0,0,0,.9165.1489l18-6a1,1,0,0,0,0-1.8974ZM10,13,4.6665,9,10,5Zm4-.0542-2,.667V4.3872l2,.667Zm4-1.333-2,.6665V5.7207l2,.6665Zm2-.667V7.0542L25.8379,9Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M20,22a4,4,0,0,0-8,0h2a2,2,0,1,1,2,2H8v2h8A4.0045,4.0045,0,0,0,20,22Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a4.0045,4.0045,0,0,0-4,4h2a2,2,0,1,1,2,2H12v2H26a4,4,0,0,0,0-8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WindGusts.propTypes = iconPropTypes;
}
const WindPower = /*#__PURE__*/React.forwardRef(function WindPower(_ref82, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref82;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M17,28V15.8159a3.0059,3.0059,0,0,0,1.47-1.1186L27.063,17l.5176-1.9321-8.6045-2.3052a2.985,2.985,0,0,0-2.63-2.7275L14.1938,2l-1.9316.5186,2.1318,7.956a2.9588,2.9588,0,0,0-1.093,3.8115L7,20.5859,8.415,22l6.3-6.3A2.8938,2.8938,0,0,0,15,15.8154V28H2v2H30V28Zm0-15a1,1,0,1,1-1-1A1.0008,1.0008,0,0,1,17,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WindPower.propTypes = iconPropTypes;
}
const WindStream = /*#__PURE__*/React.forwardRef(function WindStream(_ref83, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref83;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2,23.5859,3.4141,26.1719,6h-5.09a16.93,16.93,0,0,0-6.3139,1.2158L10.4893,8.9272A14.93,14.93,0,0,1,4.9185,10H2v2H4.9185a16.93,16.93,0,0,0,6.3139-1.2158l4.2783-1.7114A14.93,14.93,0,0,1,21.0815,8h5.09l-2.586,2.5859L25,12l5-5Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M21,11l-1.4141,1.4141L22.1719,15H18.9014a16.9422,16.9422,0,0,0-5.9693,1.0825l-2.5664.9624A14.9456,14.9456,0,0,1,5.0986,18H2v2H5.0986a16.9422,16.9422,0,0,0,5.9693-1.0825l2.5664-.9624A14.9456,14.9456,0,0,1,18.9014,17h3.2705l-2.586,2.5859L21,21l5-5Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M17,20l-1.4141,1.4141L18.1719,24H16.5967a16.9879,16.9879,0,0,0-5.3765.8721l-1.0727.3584A14.9852,14.9852,0,0,1,5.4033,26H2v2H5.4033a16.9879,16.9879,0,0,0,5.3765-.8721l1.0727-.3584A14.9852,14.9852,0,0,1,16.5967,26h1.5752l-2.586,2.5859L17,30l5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WindStream.propTypes = iconPropTypes;
}
const WatsonHealthWindowAuto = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowAuto(_ref84, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref84;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H17V7H15zM25 15H28V17H25zM15 25H17V28H15zM4 15H7V17H4z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 7.04H9.55V10.04H7.55z",
    transform: "rotate(-45 8.55 8.548)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 7.55H24.96V9.55H21.96z",
    transform: "rotate(-45 23.454 8.555)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M22.45 21.95H24.45V24.95H22.45z",
    transform: "rotate(-45 23.452 23.446)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05 22.45H10.05V24.45H7.05z",
    transform: "rotate(-45 8.544 23.451)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M4 30H28V32H4zM4 0H28V2H4zM16 10a6 6 0 106 6A6 6 0 0016 10zm-4 6a4 4 0 014-4v8A4 4 0 0112 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthWindowAuto.propTypes = iconPropTypes;
}
const WatsonHealthWindowBase = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowBase(_ref85, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref85;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V5H15zM25 13H28V15H25zM15 23H17V26H15zM4 13H7V15H4z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 5.03H9.55V8.030000000000001H7.55z",
    transform: "rotate(-45 8.56 6.544)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 5.54H24.96V7.54H21.96z",
    transform: "rotate(-45 23.469 6.539)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 19.94H24.46V22.94H22.46z",
    transform: "rotate(-45 23.462 21.442)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04 20.45H10.04V22.45H7.04z",
    transform: "rotate(-45 8.554 21.447)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H28V30H4zM16 20a6 6 0 10-6-6A6 6 0 0016 20zm0-10v8a4 4 0 010-8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthWindowBase.propTypes = iconPropTypes;
}
const WatsonHealthWindowBlackSaturation = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowBlackSaturation(_ref86, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref86;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V5H15zM27 15H30V17H27zM15 27H17V30H15zM2 15H5V17H2z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M6.225 5.729H8.228V8.732H6.225z",
    transform: "rotate(-45 7.227 7.23)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M23.267 6.227H26.267V8.227H23.267z",
    transform: "rotate(-45 24.767 7.227)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M23.769 23.269H25.770999999999997V26.270999999999997H23.769z",
    transform: "rotate(-44.999 24.77 24.77)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47 25.126L7.591 23 9 24.419 6.884 26.54 5.47 25.126zM15 13H17V15H15zM19 13H21V15H19zM17 11H19V13H17zM17 15H19V17H17zM17 19H19V21H17zM15 17H17V19H15zM19 17H21V19H19z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,7ZM9,16a7.004,7.004,0,0,1,6-6.92V11h2V9.08a6.9231,6.9231,0,0,1,2,.605V11h1.89c.0374.0366.074.0732.11.11V13h1.3149a6.931,6.931,0,0,1,.6053,2H21v2h1.92a6.931,6.931,0,0,1-.6053,2H21v1.89c-.0364.0372-.073.0738-.11.11H19v1.3149a6.9231,6.9231,0,0,1-2,.605V21H15v1.92A7.004,7.004,0,0,1,9,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthWindowBlackSaturation.propTypes = iconPropTypes;
}
const WatsonHealthWindowOverlay = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowOverlay(_ref87, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref87;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H17V9H15zM25 17H28V19H25zM15 27H17V30H15zM4 17H7V19H4z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 9.03H9.55V12.03H7.55z",
    transform: "rotate(-45 8.558 10.545)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M21.96 9.54H24.96V11.54H21.96z",
    transform: "rotate(-45 23.466 10.54)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M22.46 23.94H24.46V26.94H22.46z",
    transform: "rotate(-45 23.459 25.443)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04 24.45H10.04V26.45H7.04z",
    transform: "rotate(-45 8.55 25.448)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H28V4H4zM16 24a6 6 0 10-6-6A6 6 0 0016 24zm0-10v8a4 4 0 010-8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthWindowOverlay.propTypes = iconPropTypes;
}
const WatsonHealthWindowPreset = /*#__PURE__*/React.forwardRef(function WatsonHealthWindowPreset(_ref88, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref88;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H17V8H15zM24 15H26V17H24zM15 24H17V26H15zM6 15H8V17H6z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 8.586H10.586V10.586H8.586z",
    transform: "rotate(-45 9.586 9.586)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 8.586H23.414V10.586H21.414z",
    transform: "rotate(-45 22.414 9.586)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 21.414H23.414V23.414H21.414z",
    transform: "rotate(-45 22.414 22.414)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M8.586 21.414H10.586V23.414H8.586z",
    transform: "rotate(-45 9.586 22.414)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,0-6-6A6,6,0,0,0,16,22Zm0-10v8a4,4,0,0,1,0-8Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthWindowPreset.propTypes = iconPropTypes;
}
const Windy = /*#__PURE__*/React.forwardRef(function Windy(_ref89, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref89;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15H8V13H21a3 3 0 10-3-3H16a5 5 0 115 5zM23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H4V18H23a5 5 0 010 10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Windy.propTypes = iconPropTypes;
}
const WindyDust = /*#__PURE__*/React.forwardRef(function WindyDust(_ref90, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref90;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M23 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H22V18h1a5 5 0 010 10zM16 18H20V20H16zM10 18H14V20H10zM4 18H8V20H4zM21 15H20V13h1a3 3 0 10-3-3H16a5 5 0 115 5zM14 13H18V15H14zM8 13H12V15H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WindyDust.propTypes = iconPropTypes;
}
const WindySnow = /*#__PURE__*/React.forwardRef(function WindySnow(_ref91, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref91;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H6V18H25a5 5 0 010 10zM23 15H10V13H23a3 3 0 10-3-3H18a5 5 0 115 5z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23H13V25H11zM13 25H15V27H13zM15 27H17V29H15zM15 23H17V25H15zM11 27H13V29H11zM6 4H8V6H6zM8 6H10V8H8zM10 8H12V10H10zM10 4H12V6H10zM6 8H8V10H6zM2 26H4V28H2zM4 28H6V30H4zM6 30H8V32H6zM6 26H8V28H6zM2 30H4V32H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WindySnow.propTypes = iconPropTypes;
}
const WindyStrong = /*#__PURE__*/React.forwardRef(function WindyStrong(_ref92, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref92;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30a5.0057,5.0057,0,0,1-5-5h2a3,3,0,1,0,3-3H4V20h9a5,5,0,0,1,0,10Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25a5.0057 5.0057 0 01-5-5h2a3 3 0 103-3H2V15H25a5 5 0 010 10zM21 12H6V10H21a3 3 0 10-3-3H16a5 5 0 115 5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WindyStrong.propTypes = iconPropTypes;
}
const WinterWarning = /*#__PURE__*/React.forwardRef(function WinterWarning(_ref93, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref93;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M21.684 19.051L19.167 19.891 13 15.486 13 7.369 15.555 5.665 14.445 4.001 12 5.631 9.555 4.001 8.445 5.665 11 7.369 11 14.057 6 10.486 6 8 4 8 4 10.279 1.684 11.051 2.316 12.949 4.833 12.11 10.28 16.001 4.833 19.891 2.316 19.051 1.684 20.949 4 21.721 4 24 6 24 6 21.515 11 17.944 11 24.631 8.445 26.335 9.555 27.999 12 26.368 14.445 27.999 15.555 26.335 13 24.631 13 17.943 18 21.515 18 24 20 24 20 21.721 22.316 20.949 21.684 19.051z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WinterWarning.propTypes = iconPropTypes;
}
const WintryMix = /*#__PURE__*/React.forwardRef(function WintryMix(_ref94, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref94;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V28H15zM17 28H19V30H17zM19 30H21V32H19zM19 26H21V28H19zM15 30H17V32H15zM13 16H15V18H13zM15 18H17V20H15zM17 20H19V22H17zM17 16H19V18H17zM13 20H15V22H13zM10 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0110 30z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.5321,6.5321,0,0,0,2,15.5V22l1,2,1-2V20.18a6.4891,6.4891,0,0,0,3.4294,1.7246L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418.977.977,0,0,0-.489-.0894V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20h-.542v.0083A.9955.9955,0,0,0,22,21v3l1,2,1-2V21.9746a6.4473,6.4473,0,0,0,2-.4761V26l1,2,1-2V20.18A6.4876,6.4876,0,0,0,24.8008,9.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WintryMix.propTypes = iconPropTypes;
}
const WirelessCheckout = /*#__PURE__*/React.forwardRef(function WirelessCheckout(_ref95, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref95;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28V26A10,10,0,0,0,28,16h2A12,12,0,0,1,18,28Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23V21a5,5,0,0,0,5-5h2A7,7,0,0,1,18,23Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11H21V7a3,3,0,0,0-3-3H12A3,3,0,0,0,9,7v4H3a1,1,0,0,0-1,1.15L3.88,24.3a2,2,0,0,0,2,1.7H15V24H5.86L4.17,13H27ZM11,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WirelessCheckout.propTypes = iconPropTypes;
}
const Wmv = /*#__PURE__*/React.forwardRef(function Wmv(_ref96, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref96;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M29 9L27 22 25 9 23 9 25.52 23 28.48 23 31 9 29 9zM19 9L17.48 14 17 15.98 16.54 14 15 9 13 9 13 23 15 23 15 15 14.84 13 15.42 15 17 19.63 18.58 15 19.16 13 19 15 19 23 21 23 21 9 19 9zM9.2 9L8.86 17 8.6 21.54 8.19 18 7.51 12.54 5.49 12.54 4.81 18 4.4 21.54 4.14 17 3.8 9 2 9 3 23 5.27 23 6.03 18.07 6.49 14 6.5 13.97 6.51 14 6.97 18.07 7.73 23 10 23 11 9 9.2 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Wmv.propTypes = iconPropTypes;
}
const WordCloud = /*#__PURE__*/React.forwardRef(function WordCloud(_ref97, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref97;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16H22V18H10zM10 20H18V22H10z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a8.0233,8.0233,0,0,1,7.8649,6.4935l.2591,1.346,1.3488.244A5.5019,5.5019,0,0,1,24.5076,26H7.4954a5.5019,5.5019,0,0,1-.9695-10.9165l1.3488-.244.2591-1.346A8.0256,8.0256,0,0,1,16,7m0-2a10.0244,10.0244,0,0,0-9.83,8.1155A7.5019,7.5019,0,0,0,7.4911,28H24.5076a7.5019,7.5019,0,0,0,1.3213-14.8845A10.0229,10.0229,0,0,0,15.9883,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WordCloud.propTypes = iconPropTypes;
}
const WorkflowAutomation = /*#__PURE__*/React.forwardRef(function WorkflowAutomation(_ref98, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref98;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 27c-3.6 0-7.1-1.8-9.2-5H12v-2H4v8h2v-3.7c2.5 3 6.1 4.7 10 4.7V27zM31 23v-2h-2.1c-.1-.6-.4-1.2-.7-1.8l1.5-1.5-1.4-1.4-1.5 1.5c-.5-.3-1.1-.6-1.8-.7V15h-2v2.1c-.6.1-1.2.4-1.8.7l-1.5-1.5-1.4 1.4 1.5 1.5c-.3.5-.6 1.1-.7 1.8H17v2h2.1c.1.6.4 1.2.7 1.8l-1.5 1.5 1.4 1.4 1.5-1.5c.5.3 1.1.6 1.8.7V29h2v-2.1c.6-.1 1.2-.4 1.8-.7l1.5 1.5 1.4-1.4-1.5-1.5c.3-.5.6-1.1.7-1.8H31zM24 25c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S25.7 25 24 25zM20 10h5.2C21.9 4.9 15.1 3.5 10 6.8c-3.1 2-5 5.5-5 9.2H3C3 8.8 8.8 3 16 3c3.9 0 7.5 1.7 10 4.7V4h2v8h-8V10z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {
  WorkflowAutomation.propTypes = iconPropTypes;
}
const Workspace = /*#__PURE__*/React.forwardRef(function Workspace(_ref99, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref99;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17v8H6V17H16m0-2H6a2 2 0 00-2 2v8a2 2 0 002 2H16a2 2 0 002-2V17a2 2 0 00-2-2zM27 6v5H17V6H27m0-2H17a2 2 0 00-2 2v5a2 2 0 002 2H27a2 2 0 002-2V6a2 2 0 00-2-2zM27 17v5H22V17h5m0-2H22a2 2 0 00-2 2v5a2 2 0 002 2h5a2 2 0 002-2V17a2 2 0 00-2-2zM11 6v5H6V6h5m0-2H6A2 2 0 004 6v5a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Workspace.propTypes = iconPropTypes;
}
const WorkspaceImport = /*#__PURE__*/React.forwardRef(function WorkspaceImport(_ref100, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref100;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M27 6v5H17V6H27m0-2H17a2 2 0 00-2 2v5a2 2 0 002 2H27a2 2 0 002-2V6a2 2 0 00-2-2zM12 25H6V17h6V15H6a2 2 0 00-2 2v8a2 2 0 002 2h6zM30 20L16.828 20 19.414 17.414 18 16 13 21 18 26 19.414 24.586 16.828 22 30 22 30 20zM11 6v5H6V6h5m0-2H6A2 2 0 004 6v5a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WorkspaceImport.propTypes = iconPropTypes;
}
const Worship = /*#__PURE__*/React.forwardRef(function Worship(_ref101, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref101;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5859,17,22,21.5859v0h0l-5-5a2.002,2.002,0,0,0-2.8286,0L9.585,21.1709A2.0031,2.0031,0,0,0,9.585,24l4.0009,4H6v2H16a1,1,0,0,0,.707-1.707L11,22.585,15.5852,18l5.7078,5.707a.9995.9995,0,0,0,1.414,0L28,18.4141Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,17A3.5,3.5,0,1,1,25,13.5,3.5042,3.5042,0,0,1,21.5,17Zm0-5A1.5,1.5,0,1,0,23,13.5,1.5017,1.5017,0,0,0,21.5,12Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M4,10.5977l12-6.462,12.5264,6.7452.9472-1.7618-13-7a1.0045,1.0045,0,0,0-.9472,0l-13,7A1,1,0,0,0,2,10V30H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Worship.propTypes = iconPropTypes;
}
const WorshipChristian = /*#__PURE__*/React.forwardRef(function WorshipChristian(_ref102, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref102;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M17,30H15a2.0021,2.0021,0,0,1-2-2V14H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8h5V4a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2V8h5a2.0021,2.0021,0,0,1,2,2v2a2.0021,2.0021,0,0,1-2,2H19V28A2.0021,2.0021,0,0,1,17,30ZM8,10v2h7V28h2V12h7V10H17V4H15v6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WorshipChristian.propTypes = iconPropTypes;
}
const WorshipJewish = /*#__PURE__*/React.forwardRef(function WorshipJewish(_ref103, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref103;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M24.291,16l3.585-6.5181A1,1,0,0,0,27,8H19.8911L16.876,2.5181a1,1,0,0,0-1.752,0L12.1089,8H5a1,1,0,0,0-.876,1.4819L7.709,16,4.124,22.5181A1,1,0,0,0,5,24h7.1089l3.0151,5.4819a1,1,0,0,0,1.752,0L19.8911,24H27a1,1,0,0,0,.876-1.4819Zm-5.5823,6L16,26.9248,13.2913,22h-6.6l3.3-6-3.3-6h6.6L16,5.0752,18.7087,10h6.6l-3.3,6,3.3,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WorshipJewish.propTypes = iconPropTypes;
}
const WorshipMuslim = /*#__PURE__*/React.forwardRef(function WorshipMuslim(_ref104, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref104;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M27,18a.9986.9986,0,0,1-.5415-.1594L22,14.9688l-4.4585,2.8718a1,1,0,0,1-1.5088-1.095l1.35-5.1318L14.3105,8.69a1,1,0,0,1,.5508-1.7146l4.3745-.6128,1.8663-3.8032A1.0008,1.0008,0,0,1,21.9878,2a1.0171,1.0171,0,0,1,.8989.5378L24.88,6.3625l4.2622.6133A1,1,0,0,1,29.69,8.69l-3.0723,2.9239,1.35,5.1318A1,1,0,0,1,27,18Zm-5-5.2207a.999.999,0,0,1,.5415.1594l2.8369,1.8272-.8457-3.2149a1.0006,1.0006,0,0,1,.2778-.9787l2.0074-1.91-2.73-.3929a.9994.9994,0,0,1-.7441-.5275L22.0269,5.2151,20.7979,7.72a1.0008,1.0008,0,0,1-.7593.55L17.19,8.6687l2,1.9036a1.0006,1.0006,0,0,1,.2778.9787l-.8457,3.2149,2.8369-1.8272A.999.999,0,0,1,22,12.7793Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8169,30A13.8137,13.8137,0,0,1,9.0752,4.1277a1,1,0,0,1,1.3613,1.3611A11.8091,11.8091,0,0,0,26.5107,21.5635a1,1,0,0,1,1.3619,1.3611A13.8411,13.8411,0,0,1,15.8169,30ZM7.3271,7.9727a11.81,11.81,0,0,0,16.7,16.7,13.8086,13.8086,0,0,1-16.7-16.7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WorshipMuslim.propTypes = iconPropTypes;
}
const QX = /*#__PURE__*/React.forwardRef(function QX(_ref105, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref105;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QX.propTypes = iconPropTypes;
}
const XAxis = /*#__PURE__*/React.forwardRef(function XAxis(_ref106, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref106;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20l-1.4141,1.4141L24.1719,24H6V4H4V24a2.0023,2.0023,0,0,0,2,2H24.1719l-2.586,2.5859L23,30l5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  XAxis.propTypes = iconPropTypes;
}
const Xls = /*#__PURE__*/React.forwardRef(function Xls(_ref107, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref107;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23H22V21h6V17H24a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24v4h4a2.002 2.002 0 012 2v4A2.0023 2.0023 0 0128 23zM14 21L14 9 12 9 12 23 20 23 20 21 14 21zM10 9L8 9 6 15 4 9 2 9 4.752 16 2 23 4 23 6 17 8 23 10 23 7.245 16 10 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Xls.propTypes = iconPropTypes;
}
const Xml = /*#__PURE__*/React.forwardRef(function Xml(_ref108, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref108;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM18 9L16.48 14 16 15.98 15.54 14 14 9 12 9 12 23 14 23 14 15 13.84 13 14.42 15 16 19.63 17.58 15 18.16 13 18 15 18 23 20 23 20 9 18 9zM10 9L8 9 6 15 4 9 2 9 4.75 16 2 23 4 23 6 17 8 23 10 23 7.25 16 10 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Xml.propTypes = iconPropTypes;
}
const QY = /*#__PURE__*/React.forwardRef(function QY(_ref109, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref109;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L18 9 16 16 14 9 12 9 15 18 15 23 17 23 17 18 20 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QY.propTypes = iconPropTypes;
}
const YAxis = /*#__PURE__*/React.forwardRef(function YAxis(_ref110, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref110;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M8,26V7.8281l2.5859,2.586L12,9,7,4,2,9l1.4141,1.4141L6,7.8281V26a2.0023,2.0023,0,0,0,2,2H28V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  YAxis.propTypes = iconPropTypes;
}
const QZ = /*#__PURE__*/React.forwardRef(function QZ(_ref111, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref111;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QZ.propTypes = iconPropTypes;
}
const ZLpar = /*#__PURE__*/React.forwardRef(function ZLpar(_ref112, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref112;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10h4c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3c-1.1046,0-2,.8954-2,2V15h-3V5c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2V27c0,1.1046,.8954,2,2,2H12c1.1046,0,2-.8954,2-2v-10h3v8c0,1.1046,.8954,2,2,2h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3v-8h3v1c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-4c-1.1046,0-2,.8954-2,2v1h-3V7h3v1c0,1.1046,.8954,2,2,2Zm0-6h4v4s-4,0-4,0V4ZM11.3992,12l-7.3992,5.9194V6.0806l7.3992,5.9194Zm.6013,2.0801l.0007,11.8403-7.4004-5.9204,7.3997-5.9199Zm-.0002-4.1606L5.8508,5h6.1492l.0002,4.9194ZM4,22.0806l6.1492,4.9194H4v-4.9194Zm20,1.9194h4v4h-4v-4Zm0-10h4v4h-4v-4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZLpar.propTypes = iconPropTypes;
}
const ZSystems = /*#__PURE__*/React.forwardRef(function ZSystems(_ref113, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref113;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3h-8c-1.1028 0-2 .8975-2 2V27c0 1.1025.8972 2 2 2h8c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 6.9194l-6.1494-4.9194h6.1492l.0002 4.9194zm-.6011 2.0806l-7.3992 5.9194V6.0806l7.3992 5.9194zm.6013 2.0801l.0007 11.8403-7.4004-5.9204 7.3997-5.9199zm-8.0005 8.0005l6.1492 4.9194h-6.1492v-4.9194zM13 3H5c-1.1028 0-2 .8975-2 2V27c0 1.1025.8972 2 2 2H13c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 6.9194L6.8508 5h6.1492l.0002 4.9194zm-.6011 2.0806l-7.3992 5.9194V6.0806l7.3992 5.9194zm.6013 2.0801l.0007 11.8403-7.4004-5.9204 7.3997-5.9199zM5 22.0806l6.1492 4.9194H5v-4.9194z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZSystems.propTypes = iconPropTypes;
}
const ZAxis = /*#__PURE__*/React.forwardRef(function ZAxis(_ref114, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref114;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M26 22L26 25.586 17 16.586 17 10 17 6 17 5.828 19.586 8.414 21 7 16 2 11 7 12.414 8.414 15 5.828 15 6 15 10 15 16.586 6 25.586 6 22 4 22 4 29 11 29 11 27 7.414 27 16 18.414 24.586 27 21 27 21 29 28 29 28 22 26 22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZAxis.propTypes = iconPropTypes;
}
const Zip = /*#__PURE__*/React.forwardRef(function Zip(_ref115, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref115;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9H22V23h2V18h4a2 2 0 002-2V11A2 2 0 0028 9zm0 7H24V11h4zM12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9zM10 9L2 9 2 11 8 11 2 21 2 23 10 23 10 21 4 21 10 11 10 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Zip.propTypes = iconPropTypes;
}
const ZipReference = /*#__PURE__*/React.forwardRef(function ZipReference(_ref116, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref116;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 2H22V16h2V11h4a2 2 0 002-2V4A2 2 0 0028 2zm0 7H24V4h4zM12 4L15 4 15 14 12 14 12 16 20 16 20 14 17 14 17 4 20 4 20 2 12 2 12 4zM2 4L8 4 2 14 2 16 10 16 10 14 4 14 10 4 10 2 2 2 2 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZipReference.propTypes = iconPropTypes;
}
const ZoomArea = /*#__PURE__*/React.forwardRef(function ZoomArea(_ref117, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref117;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZoomArea.propTypes = iconPropTypes;
}
const ZoomFit = /*#__PURE__*/React.forwardRef(function ZoomFit(_ref118, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref118;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H8V10a2.0023 2.0023 0 012-2h2v2H10zM18 12H16V10H14V8h2a2.0023 2.0023 0 012 2zM12 18H10a2.0023 2.0023 0 01-2-2V14h2v2h2zM16 18H14V16h2V14h2v2A2.0023 2.0023 0 0116 18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZoomFit.propTypes = iconPropTypes;
}
const ZoomIn = /*#__PURE__*/React.forwardRef(function ZoomIn(_ref119, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref119;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
      d: "M9 6L7 6 7 4 6 4 6 6 4 6 4 7 6 7 6 9 7 9 7 7 9 7z"
    })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
      d: "M10.7,10C11.5,9,12,7.8,12,6.5C12,3.5,9.5,1,6.5,1S1,3.5,1,6.5S3.5,12,6.5,12c1.3,0,2.5-0.5,3.5-1.3l3.8,3.8l0.7-0.7 L10.7,10z M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11L6.5,11z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12L14 12 14 8 12 8 12 12 8 12 8 14 12 14 12 18 14 18 14 14 18 14 18 12z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZoomIn.propTypes = iconPropTypes;
}
const ZoomInArea = /*#__PURE__*/React.forwardRef(function ZoomInArea(_ref120, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref120;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19L21 19 21 16 19 16 19 19 16 19 16 21 19 21 19 24 21 24 21 21 24 21 24 19z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZoomInArea.propTypes = iconPropTypes;
}
const ZoomOut = /*#__PURE__*/React.forwardRef(function ZoomOut(_ref121, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref121;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
      d: "M4 6H9V7H4z"
    })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
      d: "M10.7,10C11.5,9,12,7.8,12,6.5C12,3.5,9.5,1,6.5,1S1,3.5,1,6.5S3.5,12,6.5,12c1.3,0,2.5-0.5,3.5-1.3l3.8,3.8l0.7-0.7 L10.7,10z M6.5,11C4,11,2,9,2,6.5S4,2,6.5,2S11,4,11,6.5S9,11,6.5,11L6.5,11z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H18V14H8z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4479,20A10.856,10.856,0,0,0,24,13,11,11,0,1,0,13,24a10.856,10.856,0,0,0,7-2.5521L27.5859,29,29,27.5859ZM13,22a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZoomOut.propTypes = iconPropTypes;
}
const ZoomOutArea = /*#__PURE__*/React.forwardRef(function ZoomOutArea(_ref122, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref122;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19H24V21H16z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L29.5859 31zM20 26a6 6 0 116-6A6.0066 6.0066 0 0120 26zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZoomOutArea.propTypes = iconPropTypes;
}
const ZoomReset = /*#__PURE__*/React.forwardRef(function ZoomReset(_ref123, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref123;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4478,21A10.855,10.855,0,0,0,25,14,10.99,10.99,0,0,0,6,6.4658V2H4v8h8V8H7.332a8.9768,8.9768,0,1,1-2.1,8H3.1912A11.0118,11.0118,0,0,0,14,25a10.855,10.855,0,0,0,7-2.5522L28.5859,30,30,28.5859Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ZoomReset.propTypes = iconPropTypes;
}
const WatsonHealthZoomPan = /*#__PURE__*/React.forwardRef(function WatsonHealthZoomPan(_ref124, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref124;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M27.01 12L25.6 13.41 28.18 16 25.59 18.59 27.01 20 31.01 16 27.01 12zM6.41 13.42L5 12 1 16 5 20 6.42 18.59 3.83 16 6.41 13.42zM16 28.17L13.41 25.58 12 27 16 31 20 27 18.59 25.59 16 28.17zM16 3.83L18.58 6.41 20 5 16 1 12 5 13.41 6.42 16 3.83zM22 16a6 6 0 10-2.53 4.89l3.82 3.82 1.42-1.42-3.82-3.82A6 6 0 0022 16zm-6 4a4 4 0 114-4A4 4 0 0116 20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthZoomPan.propTypes = iconPropTypes;
}
const Zos = /*#__PURE__*/React.forwardRef(function Zos(_ref125, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref125;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22h-5v-2h5v-3h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h5v2h-5v3h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zM21 22h-3c-1.1028 0-2-.8972-2-2V12c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-3-10v8h3V12h-3zM11.9458 10L7.9458 22 10.0542 22 14.0542 10 11.9458 10zM6 22L0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Zos.propTypes = iconPropTypes;
}

export { QX, QY, QZ, ViewFilled, ViewMode_1, ViewMode_2, ViewNext, ViewOff, ViewOffFilled, VirtualColumn, VirtualColumnKey, VirtualDesktop, VirtualMachine, VirtualPrivateCloud, VirtualPrivateCloudAlt, VisualRecognition, Vlan, VlanIbm, VmdkDisk, VoiceActivate, Voicemail, VolumeBlockStorage, VolumeDown, VolumeDownAlt, VolumeDownFilled, VolumeDownFilledAlt, VolumeFileStorage, VolumeMute, VolumeMuteFilled, VolumeObjectStorage, VolumeUp, VolumeUpAlt, VolumeUpFilled, VolumeUpFilledAlt, Vpn, VpnConnection, VpnPolicy, Wallet, Warning, WarningAlt, WarningAltFilled, WarningAltInverted, WarningAltInvertedFilled, WarningDiamond, WarningFilled, WarningHex, WarningHexFilled, WarningMultiple, WarningOther, WarningSquare, WarningSquareFilled, Watch, Watson, WatsonHealthWindowAuto, WatsonHealthWindowBase, WatsonHealthWindowBlackSaturation, WatsonHealthWindowOverlay, WatsonHealthWindowPreset, WatsonHealthZoomPan, WatsonMachineLearning, Watsonx, WatsonxAi, WatsonxData, WatsonxGovernance, WaveDirection, WaveHeight, WavePeriod, WeatherFrontCold, WeatherFrontStationary, WeatherFrontWarm, WeatherStation, WebServicesCluster, WebServicesContainer, WebServicesDefinition, WebServicesService, WebServicesTask, WebServicesTaskDefinitionVersion, Webhook, Websheet, Wheat, WhitePaper, Wifi, WifiBridge, WifiBridgeAlt, WifiController, WifiNotSecure, WifiOff, WifiSecure, Wikis, WindGusts, WindPower, WindStream, Windy, WindyDust, WindySnow, WindyStrong, WinterWarning, WintryMix, WirelessCheckout, Wmv, WordCloud, WorkflowAutomation, Workspace, WorkspaceImport, Worship, WorshipChristian, WorshipJewish, WorshipMuslim, XAxis, Xls, Xml, YAxis, ZAxis, ZLpar, ZSystems, Zip, ZipReference, ZoomArea, ZoomFit, ZoomIn, ZoomInArea, ZoomOut, ZoomOutArea, ZoomReset, Zos };
